/** Which sign the print page renders (G3): a branch-level page, or one table by id. */
export const QR_KINDS = ['restaurant', 'branch', 'take_away', 'table'] as const
export type QrKind = (typeof QR_KINDS)[number]

export interface QrPrintSearch {
  kind: QrKind
  /** The table id; only read with `kind: 'table'`. */
  table?: string
}

function isKind(value: unknown): value is QrKind {
  return typeof value === 'string' && (QR_KINDS as readonly string[]).includes(value)
}

/** An unknown kind falls back to the branch page; a table id is kept only when it is a string. */
export function parseQrPrintSearch(search: Record<string, unknown>): QrPrintSearch {
  const kind = isKind(search.kind) ? search.kind : 'branch'
  return typeof search.table === 'string' && search.table !== '' ? { kind, table: search.table } : { kind }
}
